// @ts-ignore
import content from './md/5-automated-follow-up-sequences.md';

export const meta = {
  slug: '5-automated-follow-up-sequences',
  title: '5 Automated Follow-Up Sequences That Convert Home Service Leads Into Paying Customers',
  excerpt: 'Learn how automated follow-up sequences can help you convert more leads into paying customers while you focus on delivering great service.',
  date: 'January 2025',
  readTime: '8 min read',
  image: '/docs/5-automated-follow-up-sequences/header.png'
};

export { content };
